import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

import ReactLoading from 'react-loading';

import { FormControlLabel, Checkbox, Grid } from '@material-ui/core';

import { FormattedMessage } from 'react-intl';

import { withRoomContext } from '../../RoomContext';
import * as settingsActions from '../../actions/settingsActions';
import * as meActions from '../../actions/meActions';

import { meProducersSelector } from '../Selectors';

import * as appPropTypes from '../appPropTypes';

import PreviewVideo from './PreviewVideo';

import Logger from '../../Logger';

const logger = new Logger('VirtualBgSettings');

const styles = (theme) => ({
	setting : {
		padding : theme.spacing(2)
	},
	formControl :
	{
		display : 'flex'
	},
	videoContainer : {
		flex               : '0 0 auto',
		boxShadow          : 'var(--peer-shadow)',
		border             : 'var(--peer-border)',
		backgroundColor    : 'var(--peer-bg-color)',
		backgroundImage    : `url(${window.config.peerEmptyAvator})`,
		backgroundPosition : 'bottom',
		backgroundSize     : 'auto 85%',
		backgroundRepeat   : 'no-repeat',
		zIndex             : 0,

		width             : '100%',
		display           : 'flex',
		alignItems        : 'center',
		justifyContent    : 'center'
	},
	bgContainer : {
		padding             : theme.spacing(1),
		margin              : '0 auto',
		display             : 'grid',
		gridTemplateColumns : 'repeat(6, 1fr)',
		overflow            : 'hidden',
		gap                 : theme.spacing(2)
	},
	bgItemView : {
		cursor              : 'pointer',
		textAlign           : 'center',
		position            : 'relative',
	},
	thumbnail :{
		borderRadius        : 'var(--layout-border-radius)',
		width               : '100%',
		'&.selected' :
		{
			borderColor : 'var(--selected-peer-border-color)',
			boxShadow : '0px 1px 3px rgba(0, 0, 0, 0.05) inset, 0px 0px 8px rgba(82, 168, 236, 0.9)',
		},
	},
	virtualAlias : {
		position     : 'absolute',
		color        : '#fff',
		top          : '50%',
		left         : '50%',
		transform    : 'translate(-50%, -50%)'
	},
	virtualSelectedTag : {
		position     : 'absolute',
		top          : '0',
		right        : '0'
	}
});

class VirtualBgSettings extends React.PureComponent
{
	constructor(props)
	{
		super(props);

		this.state = {
			videoTrackLoading     : true,
			videoTrack            : null
		};
		this._localStream = null;
	}

	async componentDidMount()
	{
		const {
			roomClient,
			joined,
			webcamProducer,
			vBgType,
			setPreloadWebcam
		} = this.props;

		const videoVisible = (
			Boolean(webcamProducer) &&
			!webcamProducer.locallyPaused &&
			!webcamProducer.remotelyPaused
		);

		logger.debug(`virtualBgSettings -> componentDidMount: [joined:${joined} videoVisible:${videoVisible}]`);

		setPreloadWebcam(true)

		if (!videoVisible) {

			const { selectedWebcam, resolution, frameRate } = this.props;

			let track = null;

			this._localStream = await navigator.mediaDevices.getUserMedia({
				video: {
					deviceId: { ideal: selectedWebcam },
					...window.config.VIDEO_CONSTRAINS[resolution],
					frameRate
				}
			});

			[ track ] = this._localStream.getVideoTracks()

			// 这里对视频进行处理
			roomClient.virtualReality.videoTrack = track;
			roomClient.virtualReality.vBgType = vBgType;

			track = await roomClient.virtualReality.transformMediaTrack();

			this.setState({

				videoTrack : track
			}, () => {

				logger.debug(`通过 getUserMedia 获取视频流`);

				//this.setState({ videoTrackLoading: false })
				setPreloadWebcam(false);
			})
		} else {

			logger.debug(`通过 webcamProducer 获取视频流`);

			this.setState({

				videoTrack : webcamProducer && webcamProducer.track
			}, () => {

				//this.setState({ videoTrackLoading: false })
				setPreloadWebcam(false);
			})
		}
	}

	componentWillUnmount()
	{
		if (this._localStream) {

			logger.debug(`通过 track.stop() 清理视频流`)

			this._localStream.getVideoTracks().map((track) => track.stop());

			this._localStream = null;
		}
	}

	render() {

		const { roomClient, virtualBgUrl, toggleMirrorOwnVideo, mirrorOwnVideo, classes, webcamProducer, setPreloadWebcam } = this.props;

		const { videoTrack, videoTrackLoading } = this.state;

		const videoVisible = (
			Boolean(videoTrack) &&
			videoTrack.enabled
		);

		return (
			<React.Fragment>
				<form className={classes.setting} autoComplete='off'>

					<Grid container spacing={2}>
						<Grid item xs={12}
							style={{padding: 0}}
							className={
								classnames(
									classes.videoContainer
								)
							}
						>

						{
						//videoTrackLoading ?
						//	<ReactLoading type='bars' className={classnames(classes.preloading)} />
						//	:
							<PreviewVideo
								isMirrored={mirrorOwnVideo}
								videoTrack={videoTrack}
								videoVisible={videoVisible}
								videoContain
							>
							</PreviewVideo>
						}

						</Grid>

						<Grid item xs={12}>
							<Grid container>
								<Grid item xs={12}>
									<FormattedMessage
										id='label.virtualBgTitle'
										defaultMessage='Virtual Background'
									/>
								</Grid>
								<Grid item xs={12}>
									<div className={classnames(classes.bgContainer)}>
									{
										window.virtualBg && Object.values(window.virtualBg).filter(item => item.tag.startsWith('virtual_small')).map((item, key) => {
											return (
												<div
													key={key}
													className={classnames(classes.bgItemView)}

													onClick={

														async () => {

															const _timestamp = Date.now();

															logger.debug(`点击事件正在执行中...${_timestamp}`);

															let _vBgType = -1;
															switch (item.tag) {
																case 'virtual_small_none_bg':  // 无背景

																	_vBgType = -1;
																	break;
																case 'virtual_small_blur_bg':  // 背景模糊

																	_vBgType = 0;
																	break;
																default:

																	_vBgType = 1;
																	break;
															}

															const _tag = item.tag;
															logger.debug(`选择 -> ${_tag} _vBgType:${_vBgType}`);

															const _prevVBgType = roomClient.virtualReality.vBgType;

															// 方案一
															if (webcamProducer && webcamProducer.track) {

																if ((_vBgType === -1 && [0, 1].includes(_prevVBgType)) ||
																	([0, 1].includes(_vBgType) && _prevVBgType === -1)
																) {

																	// 视频加载中...
																	// this.setState({ videoTrackLoading: true })
																	setPreloadWebcam(true)

																	roomClient.virtualReality.vBgType = _vBgType;

																	await roomClient.updateWebcam({ start: true });

																	// 视频加载完成...
																	//this.setState({ videoTrackLoading: false })
																	setPreloadWebcam(false)
																}
															}

															let _videoTrack = await roomClient.virtualReality.changeBackground(item.imgUrl, _prevVBgType, _vBgType);

															// 方案二
															/*
															if (webcamProducer && webcamProducer.track) {

																if ((_vBgType === -1 && [0, 1].includes(_prevVBgType)) ||
																	([0, 1].includes(_vBgType) && _prevVBgType === -1)
																) {

																	roomClient.virtualReality.vBgType = _vBgType;

																	if (_videoTrack) {

																		const _cloneVideoTrack = _videoTrack.clone();

																		await roomClient.updateWebcam({videoTrack: _cloneVideoTrack, start: true });

																		_videoTrack = _cloneVideoTrack;
																	}
																}
															}
															*/

															this.setState({ videoTrack: _videoTrack }, async () => {

																logger.debug(`当前视频:${(_videoTrack && _videoTrack.id)}`);
															});

															logger.debug(`点击事件执行完毕...${_timestamp}`);

														}

													}
												>
													<img alt={item.alias}
														className={classnames(classes.thumbnail, {
															selected : virtualBgUrl === item.imgUrl,
														})}

														src={`${window.app_base_path}${item.imgUrl}`}>

													</img>
													{(virtualBgUrl === item.imgUrl) &&
														<img
															className={classnames(classes.virtualSelectedTag)}
															src={`${window.app_base_path + '/svg/settings/checkbox_selected.svg'}`}
														>
														</img>}
													<div className={classes.virtualAlias}>{item.alias}</div>
												</div>
												)
										})
									}
									</div>
								</Grid>
							</Grid>
						</Grid>

						<Grid item xs={12}>
							<FormControlLabel control={<Checkbox
								checked={mirrorOwnVideo}
								onChange={(event) =>
								{
									const _mirrorOwnVideo = event.target.value;

									if (_mirrorOwnVideo !== null) {
										toggleMirrorOwnVideo(_mirrorOwnVideo);
									}
								}} />}
								label={<FormattedMessage
								id='settings.mirrorVideo'
								defaultMessage='Mirror video(Flip left and right)'
							/>} />
						</Grid>
					</Grid>

				</form>

			</React.Fragment>
		);
	}
}

VirtualBgSettings.propTypes =
{
	roomClient              : PropTypes.any.isRequired,
	mirrorOwnVideo          : PropTypes.bool.isRequired,

	mirrorOwnVideo          : PropTypes.bool.isRequired,
	selectedWebcam          : PropTypes.string.isRequired,
	resolution              : PropTypes.string.isRequired,
	frameRate               : PropTypes.number.isRequired,

	toggleMirrorOwnVideo    : PropTypes.func.isRequired,
	setVirtualBgUrl         : PropTypes.func.isRequired,
	classes                 : PropTypes.object.isRequired,
	joined                  : PropTypes.bool.isRequired,
	vBgType                 : PropTypes.number.isRequired,
	virtualBgUrl            : PropTypes.string.isRequired,

	webcamProducer          : appPropTypes.Producer,

};

const mapStateToProps = (state) =>
{
	return {
		joined             : state.room.joined,
		vBgType            : state.me.vBgType,
		virtualBgUrl       : state.me.virtualBgUrl,
		...meProducersSelector(state),
		mirrorOwnVideo     : state.settings.mirrorOwnVideo,
		selectedWebcam     : state.settings.selectedWebcam,
		resolution         : state.settings.resolution,
		frameRate          : state.settings.frameRate
	};
};

const mapDispatchToProps = (dispatch) =>
{
	return {
		toggleMirrorOwnVideo : (flag) =>
		{
			dispatch(settingsActions.toggleMirrorOwnVideo(flag));
		},
		setVirtualBgUrl : (imgUrl) =>
		{
			dispatch(meActions.setVirtualBgUrl(imgUrl));
		},
		setPreloadWebcam : (flag) =>
		{
			dispatch(meActions.setPreloadWebcam(flag));
		}
	};
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room.joined === next.room.joined &&
				prev.me.vBgType === next.me.vBgType &&
				prev.me.virtualBgUrl === next.me.virtualBgUrl &&
				prev.producers === next.producers &&
				prev.settings.mirrorOwnVideo === next.settings.mirrorOwnVideo &&
				prev.settings.selectedWebcam === next.settings.selectedWebcam &&
				prev.settings.resolution === next.settings.resolution &&
				prev.settings.frameRate === next.settings.frameRate
			);
		}
	}
)(withStyles(styles)(VirtualBgSettings)));